import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import numeral from "numeral";
import { VaporHorizontalStepper } from "../../../../vapor";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RemovalSubSectionPage2 = ({setPage, isSimulationLoading, simulationData}) => {
  const intl = useIntl();
  const steps = [
    {
      number: 1,
      title: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.eliminationData"}),
      clickable: true
    },
    {
      number: 2,
      title: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.previewAccount"}), 
      clickable: false
    }
  ];
  // const state =  {
  //   reason: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.assetDelete"}),
  //   reasonId: "TS1",
  //   sectional: "1",
  //   regime: "Ordinario",
  //   debit: [{
  //     accountDesc: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.accountDescDebit"}),
  //     amount: 7500
  //   }],
  //   credit:[{
  //     accountDesc: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.accountDescCredit"}),
  //     amount: 10000
  //   }]
  // };
  const [debitList, setDebitList] = useState([]);
  const [creditList, setCreditList] = useState([]);

  useEffect(() => {
    if (!simulationData) return;
    setDebitList(simulationData?.simulation?.accountingLines.filter(el => el.debit["EUR"] > 0));
    setCreditList(simulationData?.simulation?.accountingLines.filter(el => el.credit["EUR"] > 0));
  }, [simulationData]);

  return isSimulationLoading ?
    <div 
      style={{display: "flex", 
        alignItems: "center", 
        width: "100%", 
        justifyContent: "center"}}>
      <FontAwesomeIcon 
        icon={["far", "circle-notch"]}
        spin
        style={{
          fontSize: "40px",
          color: "#1890FF"
        }}
      />
    </div> 
    : (
      <>
        <VaporHorizontalStepper 
          currentStep={2}
          steps={steps}
          setCurrentStep={stepNumber => {          
            if (stepNumber===1)
              setPage(stepNumber);
          }}
          readOnly={false}
        />
        <div className="pre-cog-assets-drawer-titles" style={{ marginTop: "40px" }}>
          <FormattedMessage id="preCog.assetsTab.drawer.fixedAsset" /> 
        </div>
        <div style={{display: "flex", marginBottom: "16px"}}>        
          <div>
            <FormattedMessage id="preCog.assetsTab.drawer.movements.causalAccounting" />:
            <span className="precog-withholding-drawer-form—label-text"> ({simulationData?.simulation?.reasonId})</span>
          </div>
        </div>
        <div style={{display: "flex", justifyContent: "space-between"}}>
          <div style={{width: "50%"}}>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.accountingAccount" />
              </div>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.give" />
              </div>
            </div>
            {debitList?.map((row,index) => 
              <div key={index} style={{display: "flex", justifyContent: "space-between"}}>
                <div style={{width: "70%"}}>{row?.accountDesc}</div>
                <div>{numeral(row?.debit.EUR).format("0,0.00")} €</div>
              </div>)}
          </div>
          <div className={"pre-cog-assets-drawer-hr-vertical"} >&nbsp;</div>
          <div style={{width: "40%"}}>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.accountingAccount" />
              </div>
              <div className="precog-withholding-drawer-form—label-text"> 
                <FormattedMessage id="preCog.assetsTab.drawer.movements.have" />
              </div>
            </div>
            {creditList?.map((row,index) => 
              <div key={index} style={{display: "flex", justifyContent: "space-between"}}>
                <div style={{width: "70%"}}>{row?.accountDesc}</div>
                <div>{numeral(row?.credit.EUR).format("0,0.00")} €</div>
              </div>)}
          </div>
        </div>
      </>
    );
};

export default RemovalSubSectionPage2;